import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';

import { SpeakersState } from './types';
import { RootState } from '@/store/main';
import { FetchSpeakers } from '@/connection/speakers/speakers';
import { Speaker } from '@/types/speakers.types';

export const reducers = (create: ReducerCreators<SpeakersState>) => ({
  fetchSpeakers: create.asyncThunk(
    async (
      { channel, returnStoreStateIfExists = true }: { channel: number; returnStoreStateIfExists?: boolean },
      { getState }
    ) => {
      if (returnStoreStateIfExists) {
        // return from state if exists
        const state = getState() as RootState;
        const speakers = state?.speakers?.speakers as Speaker[] | null;
        if (speakers) {
          return speakers;
        }
      }
      return FetchSpeakers(channel);
    },
    {
      fulfilled: (state, action) => {
        state.speakers = action.payload;
        state.loadingSpeakers = false;
      },
      pending: (state) => {
        state.loadingSpeakers = true;
      },
      rejected: (state, action) => {
        state.loadingSpeakers = false;
        console.error(action.error);
        // TODO
        // add an error to state and show alert in the UI component
      },
    }
  ),
  setNewSpeaker: create.reducer((state, action: PayloadAction<Speaker>) => {
    if (state.loadingSpeakers) return state;
    state.speakers = [...(state.speakers || []), ...[action.payload]];
  }),
});
